/* eslint-disable no-useless-escape */
// eslint-disable-next-line no-undef
tinymce.addI18n("es_MX", {
  Redo: "Rehacer",
  Undo: "Deshacer",
  Cut: "Cortar",
  Copy: "Copiar",
  Paste: "Pegar",
  "Select all": "Seleccionar todo",
  "New document": "Nuevo documento",
  Ok: "Aceptar",
  Cancel: "Cancelar",
  "Visual aids": "Ayudas visuales",
  Bold: "Negrita",
  Italic: "Cursiva",
  Underline: "Subrayado",
  Strikethrough: "Tachado",
  Superscript: "Super\u00edndice",
  Subscript: "Sub\u00edndice",
  "Clear formatting": "Borrar formato",
  "Align left": "Alinear a la izquierda",
  "Align center": "Alinear al centro",
  "Align right": "Alinear a la derecha",
  Justify: "Justificar",
  "Bullet list": "Lista de vi\u00f1etas",
  "Numbered list": "Lista numerada",
  "Decrease indent": "Reducir sangr\u00eda",
  "Increase indent": "Aumentar sangr\u00eda",
  Close: "Cerrar",
  Formats: "Formatos",
  "Your browser doesn't support direct access to the clipboard. Please use the Ctrl+X/C/V keyboard shortcuts instead.":
    "Su navegador no admite el acceso directo al portapapeles. Utilice los m\u00e9todos abreviados de teclado Ctrl+ X/C/V.",
  Headers: "Encabezados",
  "Header 1": "Encabezado 1",
  "Header 2": "Encabezado 2",
  "Header 3": "Encabezado 3",
  "Header 4": "Encabezado 4",
  "Header 5": "Encabezado 5",
  "Header 6": "Encabezado 6",
  Headings: "T\u00edtulos",
  "Heading 1": "T\u00edtulo 1",
  "Heading 2": "T\u00edtulo 2",
  "Heading 3": "T\u00edtulo 3",
  "Heading 4": "T\u00edtulo 4",
  "Heading 5": "T\u00edtulo 5",
  "Heading 6": "T\u00edtulo 6",
  Preformatted: "Con formato previo",
  Div: "Div",
  Pre: "Pre",
  Code: "C\u00f3digo",
  Paragraph: "P\u00e1rrafo",
  Blockquote: "Blockquote",
  Inline: "En l\u00ednea",
  Blocks: "Bloques",
  "Paste is now in plain text mode. Contents will now be pasted as plain text until you toggle this option off.":
    "Se pegar\u00e1 en texto plano. El contenido se pegar\u00e1 como texto plano hasta que desactive esta opci\u00f3n.",
  Fonts: "Fuentes",
  "Font Sizes": "Tama\u00f1os de fuente",
  Class: "Clase",
  "Browse for an image": "Buscar una imagen",
  OR: "O",
  "Drop an image here": "Soltar una imagen aqu\u00ed",
  Upload: "Cargar",
  Block: "Bloque",
  Align: "Alinear",
  Default: "Por defecto",
  Circle: "Circulo",
  Disc: "Disco",
  Square: "Cuadro",
  "Lower Alpha": "Alfa min\u00fascula",
  "Lower Greek": "Griega min\u00fascula",
  "Lower Roman": "Romano min\u00fascula",
  "Upper Alpha": "Alfa may\u00fascula",
  "Upper Roman": "May\u00fascula Romana",
  "Anchor...": "Marcador...",
  Name: "Nombre",
  Id: "Identificador",
  "Id should start with a letter, followed only by letters, numbers, dashes, dots, colons or underscores.":
    "El Identificador debe comenzar con una letra, seguido solo por letras, n\u00fameros, puntos, guiones medios o guiones bajos.  ",
  "You have unsaved changes are you sure you want to navigate away?":
    "No se  han guardado los cambios. \u00bfSeguro que desea abandonar la p\u00e1gina?",
  "Restore last draft": "Restaurar el \u00faltimo borrador",
  "Special character...": "Car\u00e1cter especial...",
  "Source code": "C\u00f3digo fuente",
  "Insert/Edit code sample": "Insertar/Editar c\u00f3digo muestra",
  Language: "idioma",
  "Code sample...": "Ejemplo de c\u00f3digo...",
  "Color Picker": "Selector de colores",
  R: "R",
  G: "G",
  B: "B",
  "Left to right": "Izquierda a derecha",
  "Right to left": "Derecha a Izquierda",
  "Emoticons...": "Emoticonos...",
  "Metadata and Document Properties": "Metadatos y propiedades del documento",
  Title: "T\u00edtulo",
  Keywords: "Palabras clave",
  Description: "Descripci\u00f3n ",
  Robots: "Robots",
  Author: "Autor",
  Encoding: "Codificaci\u00f3n",
  Fullscreen: "Pantalla completa",
  Action: "Acci\u00f3n",
  Shortcut: "Atajo",
  Help: "Ayuda",
  Address: "Direcci\u00f3n",
  "Focus to menubar": "Enfocar en barra de menu",
  "Focus to toolbar": "Enfocar en barra de herramientas",
  "Focus to element path": "Enfocar ruta del elemento",
  "Focus to contextual toolbar": "Enfocar en barra de herramientas contextual",
  "Insert link (if link plugin activated)":
    "Insertar enlace (si enlace del plugin est\u00e1 activo)",
  "Save (if save plugin activated)":
    "Guardar (si el plugin guardar est\u00e1 activo)",
  "Find (if searchreplace plugin activated)":
    "Buscar (si el plugin buscar/reemplazar est\u00e1 activo)",
  "Plugins installed ({0}):": "Plugins instalados ({0}):",
  "Premium plugins:": "Plugins premium:",
  "Learn more...": "Aprende m\u00e1s...",
  "You are using {0}": "est\u00e1s usando {0}",
  Plugins: "Plugins",
  "Handy Shortcuts": "Atajos \u00fatiles",
  "Horizontal line": "L\u00ednea Horizontal",
  "Insert/edit image": "Insertar/editar imagen",
  "Image description": "Descripci\u00f3n de imagen",
  Source: "Origen",
  Dimensions: "Dimensiones",
  "Constrain proportions": "Restringir proporciones",
  General: "General",
  Advanced: "Avanzado",
  Style: "Estilo",
  "Vertical space": "Espacio vertical",
  "Horizontal space": "Espacio horizontal",
  Border: "Borde",
  "Insert image": "Insertar imagen",
  "Image...": "Imagen...",
  "Image list": "Lista de im\u00e1genes",
  "Rotate counterclockwise": "Rotar en sentido contrario a las manecillas",
  "Rotate clockwise": "Rotar en sentido de las manecillas",
  "Flip vertically": "Voltear verticalmente",
  "Flip horizontally": "Volter horizontalmente",
  "Edit image": "Editar imagen",
  "Image options": "Opciones de la imagen",
  "Zoom in": "Acercar",
  "Zoom out": "Alejar",
  Crop: "Recortar",
  Resize: "Cambiar tama\u00f1o",
  Orientation: "Orientaci\u00f3n",
  Brightness: "Brillo",
  Sharpen: "Nitidez",
  Contrast: "Contraste",
  "Color levels": "Niveles de Color",
  Gamma: "Gamma",
  Invert: "Invertir",
  Apply: "Aplicar",
  Back: "Regresar",
  "Insert date/time": "Insertar fecha/hora",
  "Date/time": "Fecha/hora",
  "Insert/Edit Link": "Insertar/editar v\u00ednculo",
  "Insert/edit link": "Inserta/editar enlace",
  "Text to display": "Texto a mostrar",
  Url: "Url",
  "Open link in...": "Abrir v\u00ednculo en...",
  "Current window": "Ventana actual",
  None: "Ninguno",
  "New window": "Nueva ventana",
  "Remove link": "Eliminar elnace",
  Anchors: "Anclas",
  "Link...": "V\u00ednculo...",
  "Paste or type a link": "Pega o escribe un enlace",
  "The URL you entered seems to be an email address. Do you want to add the required mailto: prefix?":
    'El URL que ha insertado tiene formato de correo electr\u00f3nico. \u00bfDesea agregar con prefijo "mailto:"?',
  "The URL you entered seems to be an external link. Do you want to add the required http:// prefix?":
    'El URL que ha ingresado es un enlace externo. \u00bfDesea agregar el prefijo "http://"?',
  "Link list": "Lista de enlaces",
  "Insert video": "Insertar video",
  "Insert/edit video": "Insertar/editar video",
  "Insert/edit media": "Insertar/editar multimedia",
  "Alternative source": "Fuente alternativa",
  "Alternative source URL": "URL de origen alternativo",
  "Media poster (Image URL)": "P\u00f3ster multimedia (URL de la imagen)",
  "Paste your embed code below:":
    "Pegue su c\u00f3digo de inserci\u00f3n abajo:",
  Embed: "Incrustar",
  "Media...": "Elemento multimedia...",
  "Nonbreaking space": "Espacio de no separaci\u00f3n",
  "Page break": "Salto de p\u00e1gina ",
  "Paste as text": "Copiar como texto",
  Preview: "Vista previa ",
  "Print...": "Imprimir...",
  Save: "Guardar",
  Find: "Buscar",
  "Replace with": "Remplazar con",
  Replace: "Remplazar",
  "Replace all": "Remplazar todo",
  Previous: "Anterior",
  Next: "Siguiente",
  "Find and replace...": "Buscar y reemplazar...",
  "Could not find the specified string.":
    "No se ha encontrado la cadena especificada.",
  "Match case": "Coincidencia",
  "Find whole words only": "Buscar solo palabras completas",
  "Spell check": "Corrector ortogr\u00e1fico",
  Ignore: "Ignorar",
  "Ignore all": "Ignorar todo",
  Finish: "Terminar",
  "Add to Dictionary": "Agregar al diccionario ",
  "Insert table": "Insertar tabla",
  "Table properties": "Propiedades de tabla",
  "Delete table": "Eliminar tabla",
  Cell: "Celda",
  Row: "Rengl\u00f3n ",
  Column: "Columna",
  "Cell properties": "Propiedades de celda",
  "Merge cells": "Unir celdas",
  "Split cell": "Dividir celdas",
  "Insert row before": "Insertar rengl\u00f3n antes",
  "Insert row after": "Insertar rengl\u00f3n despu\u00e9s",
  "Delete row": "Eliminar rengl\u00f3n ",
  "Row properties": "Propiedades del rengl\u00f3n ",
  "Cut row": "Cortar renglon",
  "Copy row": "Copiar rengl\u00f3n ",
  "Paste row before": "Pegar rengl\u00f3n antes",
  "Paste row after": "Pegar rengl\u00f3n despu\u00e9s",
  "Insert column before": "Insertar columna antes",
  "Insert column after": "Insertar columna despu\u00e9s",
  "Delete column": "Eliminar columna",
  Cols: "Columnas",
  Rows: "Renglones ",
  Width: "Ancho",
  Height: "Alto",
  "Cell spacing": "Espacio entre celdas",
  "Cell padding": "Relleno de la celda",
  "Show caption": "Mostrar leyenda",
  Left: "Izquierda",
  Center: "Centro",
  Right: "Derecha",
  "Cell type": "Tipo de celda",
  Scope: "Alcance",
  Alignment: "Alineaci\u00f3n ",
  "H Align": "Alineaci\u00f3n Horizontal",
  "V Align": "Alineaci\u00f3n Vertical",
  Top: "Arriba",
  Middle: "Centrado",
  Bottom: "Abajo",
  "Header cell": "Celda de encabezado",
  "Row group": "Grupo de renglones",
  "Column group": "Grupo de columnas",
  "Row type": "Tipo de rengl\u00f3n ",
  Header: "Encabezado",
  Body: "Cuerpo",
  Footer: "Pie",
  "Border color": "Color del borde",
  "Insert template...": "Insertar plantilla...",
  Templates: "Plantilla",
  Template: "Plantilla",
  "Text color": "Color de letra",
  "Background color": "Color de fondo",
  "Custom...": "Personalizar",
  "Custom color": "Perzonalizar color",
  "No color": "Sin color",
  "Remove color": "Eliminar color",
  "Table of Contents": "Tabla de Contenidos",
  "Show blocks": "Mostrar bloques",
  "Show invisible characters": "Mostrar caracteres invisibles",
  "Word count": "Contar palabras",
  Count: "Recuento",
  Document: "Documento",
  Selection: "Selecci\u00f3n",
  Words: "Palabras",
  "Words: {0}": "Palabras:{0}",
  "{0} words": "{0} palabras",
  File: "Archivo",
  Edit: "Editar",
  Insert: "Insertar",
  View: "Vistas",
  Format: "Formato",
  Table: "Tabla",
  Tools: "Herramientas",
  "Powered by {0}": "Creado con {0}",
  "Rich Text Area. Press ALT-F9 for menu. Press ALT-F10 for toolbar. Press ALT-0 for help":
    "Presione dentro del \u00e1rea de texto ALT-F9 para invocar el men\u00fa, ALT-F10 para la barra de herramientas y ALT-0 para la ayuda.",
  "Image title": "T\u00edtulo de la imagen",
  "Border width": "Ancho del borde",
  "Border style": "Estilo del borde",
  Error: "Error",
  Warn: "Advertencia",
  Valid: "V\u00e1lido",
  "To open the popup, press Shift+Enter":
    "Para abrir la ventana emergente, pulse May\u00fas+Intro",
  "Rich Text Area. Press ALT-0 for help.":
    "\u00c1rea de texto enriquecido. Pulse ALT-0 para obtener ayuda.",
  "System Font": "Fuente del sistema",
  "Failed to upload image: {0}": "Error al cargar la imagen: {0}",
  "Failed to load plugin: {0} from url {1}":
    "Error al cargar el complemento: {0} desde la url {1}",
  "Failed to load plugin url: {0}":
    "Error al cargar la url del complemento: {0}",
  "Failed to initialize plugin: {0}":
    "Error al inicializar el complemento: {0}",
  example: "ejemplo",
  Search: "Buscar",
  All: "Todo",
  Currency: "Moneda",
  Text: "Texto",
  Quotations: "Comillas",
  Mathematical: "Matem\u00e1ticos",
  "Extended Latin": "Lat\u00edn extendido",
  Symbols: "S\u00edmbolos",
  Arrows: "Flechas",
  "User Defined": "Definido por el usuario",
  "dollar sign": "signo de d\u00f3lar",
  "currency sign": "signo de moneda",
  "euro-currency sign": "signo de euro",
  "colon sign": "signo del col\u00f3n",
  "cruzeiro sign": "signo del cruzeiro",
  "french franc sign": "signo del franco franc\u00e9s",
  "lira sign": "signo de la lira",
  "mill sign": "signo de mil",
  "naira sign": "signo del naira",
  "peseta sign": "signo de la peseta",
  "rupee sign": "signo de la rupia",
  "won sign": "signo del won",
  "new sheqel sign": "signo de nuevo shequel",
  "dong sign": "signo del dong",
  "kip sign": "signo del kip",
  "tugrik sign": "signo del tugrik",
  "drachma sign": "signo del dracma",
  "german penny symbol": "signo del penique alem\u00e1n",
  "peso sign": "signo del peso",
  "guarani sign": "signo del guaran\u00ed",
  "austral sign": "signo del austral",
  "hryvnia sign": "signo de hryvnia",
  "cedi sign": "signo de cedi",
  "livre tournois sign": "signo de livre tournois",
  "spesmilo sign": "signo de spesmilo",
  "tenge sign": "signo de tenge",
  "indian rupee sign": "signo de la rupia india",
  "turkish lira sign": "signo de la lira turca",
  "nordic mark sign": "signo del marco n\u00f3rdico",
  "manat sign": "signo de manat",
  "ruble sign": "signo de rublo",
  "yen character": "car\u00e1cter del yen",
  "yuan character": "car\u00e1cter del yuan",
  "yuan character, in hong kong and taiwan":
    "car\u00e1cter del yuan, en Hong Kong y Taiw\u00e1n",
  "yen/yuan character variant one":
    "variante uno del car\u00e1cter del yen/yuan",
  "Loading emoticons...": "Cargando emoticonos...",
  "Could not load emoticons": "No se pudieron cargar los emoticonos",
  People: "Personas",
  "Animals and Nature": "Animales y naturaleza",
  "Food and Drink": "Comida y bebida",
  Activity: "Actividad",
  "Travel and Places": "Viajes y lugares",
  Objects: "Objetos",
  Flags: "Banderas",
  Characters: "Caracteres",
  "Characters (no spaces)": "Caracteres (sin espacios)",
  "{0} characters": "{0} caracteres",
  "Error: Form submit field collision.":
    "Error: colisi\u00f3n de campo env\u00edo de formulario.",
  "Error: No form element found.":
    "Error: no se encontr\u00f3 ning\u00fan elemento de formulario.",
  Update: "Actualizar",
  "Color swatch": "Muestrario de colores",
  Turquoise: "Turquesa",
  Green: "Verde",
  Blue: "Azul",
  Purple: "Morado",
  "Navy Blue": "Azul marino",
  "Dark Turquoise": "Turquesa oscuro",
  "Dark Green": "Verde oscuro",
  "Medium Blue": "Azul medio",
  "Medium Purple": "Morado medio",
  "Midnight Blue": "Azul noche",
  Yellow: "Amarillo",
  Orange: "Anaranjado",
  Red: "Rojo",
  "Light Gray": "Gris claro",
  Gray: "Gris",
  "Dark Yellow": "Amarillo oscuro",
  "Dark Orange": "Anaranjado oscuro",
  "Dark Red": "Rojo oscuro",
  "Medium Gray": "Gris medio",
  "Dark Gray": "Gris oscuro",
  "Light Green": "Verde claro",
  "Light Yellow": "Amarillo claro",
  "Light Red": "Rojo claro",
  "Light Purple": "Morado claro",
  "Light Blue": "Azul claro",
  "Dark Purple": "Morado oscuro",
  "Dark Blue": "Azul oscuro",
  Black: "Negro",
  White: "Blanco",
  "Switch to or from fullscreen mode":
    "Cambiar a modo de pantalla completa o salir de \u00e9l",
  "Open help dialog": "Abrir di\u00e1logo de ayuda",
  history: "historial",
  styles: "estilos",
  formatting: "formato",
  alignment: "alineaci\u00f3n",
  indentation: "sangr\u00eda",
  "permanent pen": "l\u00e1piz permanente",
  comments: "comentarios",
  "Format Painter": "Copiar formato",
  "Insert/edit iframe": "Insertar/editar marco flotante",
  Capitalization: "Uso de may\u00fasculas",
  lowercase: "min\u00fascula",
  UPPERCASE: "MAY\u00daSCULA",
  "Title Case": "Tipo t\u00edtulo",
  "Permanent Pen Properties": "Propiedades del l\u00e1piz permanente",
  "Permanent pen properties...": "Propiedades del l\u00e1piz permanente...",
  Font: "Fuente",
  Size: "Tama\u00f1o",
  "More...": "M\u00e1s...",
  "Spellcheck Language": "Idioma de la revisi\u00f3n ortogr\u00e1fica",
  "Select...": "Seleccionar...",
  Preferences: "Preferencias",
  Yes: "S\u00ed",
  No: "No",
  "Keyboard Navigation": "Navegaci\u00f3n con el teclado",
  Version: "Versi\u00f3n",
  Anchor: "Anclar",
  "Special character": "Caracter especial",
  "Code sample": "C\u00f3digo muestra",
  Color: "Color",
  Emoticons: "Emoticones",
  "Document properties": "Propiedades del documento",
  Image: "Imagen",
  "Insert link": "Insertar enlace",
  Target: "Objetivo",
  Link: "Enlace",
  Poster: "Cartel",
  Media: "Multimedia",
  Print: "Imprimir",
  Prev: "Anterior",
  "Find and replace": "Buscar y reemplazar",
  "Whole words": "Palabras completas",
  Spellcheck: "Revisi\u00f3n ortogr\u00e1fica",
  Caption: "Subt\u00edtulo",
  "Insert template": "Insertar plantilla",
});
